const ALLOWED = {
    owner: ['read', 'comment', 'editRecords', 'editSchema', 'manage'],
    creator: ['read', 'comment', 'editRecords', 'editSchema'],
    editor: ['read', 'comment', 'editRecords'],
    commenter: ['read', 'comment'],
    reader: ['read'],
};
/** What a role lets someone do in a database.  Clients use it to hide what they can't do. */
export function roleAllows(role, action) {
    return role ? ALLOWED[role].includes(action) : false;
}
//# sourceMappingURL=role-actions.js.map